function Pattern() {
  return <div className="pattern" aria-hidden="true" />;
}

export default Pattern;
